/*
  Cesera Mengenstaffel — koppelt die Stufen-Karten an Dawns Mengenfeld.

  Seit Runde 20 sind die Stufen KEINE Varianten mehr, sondern Mengen. Die Karte
  „3 Streifen" setzt also `#Quantity-<section>` auf 3; den Rabatt vergeben vier
  automatische Rabatte im Shopify-Admin. Damit steht im Warenkorb eine einzige
  Zahl, und die stimmt.

  Vier Dinge, die dieses Skript aushalten muss:

  1. Dawn ersetzt bei jedem Optionswechsel das komplette <variant-selects>
     (product-info.js:169 -> HTMLUpdateUtility.viewTransition). Alle direkt an
     die Radios gebundenen Listener waeren danach weg — deshalb haengen sie
     delegiert am `document`.
  2. Das Markup wird per DOMParser erzeugt. Darin enthaltene <script>-Tags
     laufen beim Einfuegen NICHT — dieses Skript darf also nur einmal binden
     und muss danach ohne erneute Ausfuehrung weiterarbeiten.
  3. Nach so einem Austausch kommen die Stufen servergerendert mit Stufe 1
     vorausgewaehlt zurueck, waehrend das Mengenfeld (eigener Block, wird NICHT
     ersetzt) noch den alten Wert traegt. Ohne Nachfuehren stuende die
     Markierung auf 1, im Warenkorb landeten aber 3. Dafuer der MutationObserver.
  4. Aendert jemand die Menge direkt am Stepper, muss die passende Stufe
     mitziehen — oder gar keine, wenn der Wert auf keiner Stufe liegt (z. B. 5).

  Das Mengenfeld ist die einzige Quelle der Wahrheit. Faellt dieses Skript aus,
  bleiben Stepper und Kaufbutton voll funktionsfaehig; nur die Stufen-Karten
  markieren dann nichts mehr.
*/
(function () {
  if (window.CeseraBundle) return;

  /* Zuletzt vom Menschen gewaehlte Menge, je Sektion.
     Noetig, weil Dawn beim Variantenwechsel NICHT nur <variant-selects>
     austauscht, sondern auch den Mengenblock (fuer variantenabhaengige
     Mengenregeln) — dabei faellt das Feld auf 1 zurueck. Ohne dieses
     Gedaechtnis landet „3 Streifen -> Format auf Rolle" bei 1 Rolle.
     Gesetzt wird es nur durch echte Bedienung (Stufenklick oder Stepper),
     nie durch das Wiederherstellen selbst. */
  var desired = {};

  function sectionOf(root) {
    return root.getAttribute('data-cesera-section') || '';
  }

  function quantityFieldFor(root) {
    var id = sectionOf(root);
    return id ? document.getElementById('Quantity-' + id) : null;
  }

  function markTiers(root) {
    var field = quantityFieldFor(root);
    if (!field) return;

    /* Mengenregeln der Variante respektieren: lieber die Stufe nicht
       wiederherstellen als eine unbestellbare Menge setzen. */
    var want = desired[sectionOf(root)];
    if (want != null && String(field.value) !== String(want)) {
      var max = parseInt(field.getAttribute('max'), 10);
      if (!(max > 0 && want > max)) {
        field.value = want;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var current = parseInt(field.value, 10);
    var radios = root.querySelectorAll('[data-cesera-qty]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = parseInt(radios[i].getAttribute('data-cesera-qty'), 10) === current;
    }
  }

  function syncAll() {
    var roots = document.querySelectorAll('[data-cesera-bundle]');
    for (var i = 0; i < roots.length; i++) markTiers(roots[i]);
  }

  function remember(field) {
    var root = field.closest('product-info') || document;
    var bundle = root.querySelector('[data-cesera-bundle]');
    if (bundle) desired[sectionOf(bundle)] = parseInt(field.value, 10);
  }

  function applyTier(radio) {
    var root = radio.closest('[data-cesera-bundle]');
    if (!root) return;
    var field = quantityFieldFor(root);
    if (!field) return;

    var next = radio.getAttribute('data-cesera-qty');
    desired[sectionOf(root)] = parseInt(next, 10);
    if (field.value === next) return;

    field.value = next;
    // Dawn haengt am `change` des Mengenfelds die Preis-/Bestandslogik auf.
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var tier = target.closest('[data-cesera-qty]');
    if (tier) {
      applyTier(tier);
      return;
    }
    if (target.name === 'quantity') {
      remember(target);
      syncAll();
    }
  });

  // Setzt nur .checked (Property, kein Attribut) und loest deshalb keine
  // weitere Mutation aus — die Beobachtung kann sich nicht selbst antreiben.
  if (window.MutationObserver) {
    var observer = new MutationObserver(syncAll);
    var hosts = document.querySelectorAll('product-info');
    for (var i = 0; i < hosts.length; i++) {
      observer.observe(hosts[i], { childList: true, subtree: true });
    }
  }

  window.CeseraBundle = { sync: syncAll };
  syncAll();
})();
